<template>
  <b-modal
    id="law_client_form_modal"
    ref="bvModal"
    :no-close-on-backdrop="true"
    :hide-footer="true"
  >
    <template v-slot:modal-header="{ close }">
      <div class="modal-header-buttons-container">
        <button
          class="close-modal-btn mr-7"
          id="service_form_modal_close_btn"
          @click="close()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-x"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="modal-header-title-container">
        <h2>{{ $t("lawClientFormModal.createTitle") }}</h2>
      </div>
    </template>
    <!-- client types -->
    <div class="choose-service-type-container">
      <!-- physical entity -->
      <div class="service-type-card" @click="createPhysicalEntity()">
        <div class="d-flex justify-content-between align-items-center">
          <div class="bb-badge badge-rounded service-type-badge success-light">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-users"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <div class="service-card-text">
            <p>
              {{ $t("lawClientFormModal.clientType.options.physical.label") }}
            </p>
            <span>{{
              $t("lawClientFormModal.clientType.options.physical.text")
            }}</span>
          </div>
        </div>
        <i class="la la-angle-right"></i>
      </div>
      <!-- legal entity -->
      <div class="service-type-card" @click="createLegalEntity()">
        <div class="d-flex justify-content-start align-items-center">
          <div class="bb-badge badge-rounded service-type-badge success-light">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-calendar"
            >
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
          </div>
          <div class="service-card-text">
            <p>{{ $t("lawClientFormModal.clientType.options.legal.label") }}</p>
            <span>{{
              $t("lawClientFormModal.clientType.options.legal.text")
            }}</span>
          </div>
        </div>
        <i class="la la-angle-right"></i>
      </div>
    </div>
    <PhysicalEntityFormModal
      @entityCreated="physicalEntityCreated"
      ref="physicalEntityFormModal"
    />
    <LegalEntityFormModal
      @entityCreated="legalEntityCreated"
      ref="legalEntityFormModal"
    />
  </b-modal>
</template>

<script>
import formMixin from "@/core/mixins/formMixin.js";
import physicalEntityFormMixin from "@/core/mixins/physicalEntityFormMixin.js";
import legalEntityFormMixin from "@/core/mixins/legalEntityFormMixin.js";
import PhysicalEntityFormModal from "@/view/layout/extras/modal/PhysicalEntityFormModal.vue";
import LegalEntityFormModal from "@/view/layout/extras/modal/LegalEntityFormModal.vue";

export default {
  name: "LawClientFormModal",
  mixins: [formMixin, physicalEntityFormMixin, legalEntityFormMixin],
  components: { PhysicalEntityFormModal, LegalEntityFormModal },
  emits: ["setTableViewToLegalEntities", "setTableViewToPhysicalEntities"],
  data() {
    return {};
  },
  methods: {
    /**
     * Event emitted after legal entity is created,
     * Emits event to set correct table view in parent component
     * @return {event}
     */
    legalEntityCreated() {
      this.closeModal();
      this.$emit("setTableViewToLegalEntities");
    },
    /**
     * Emitted after physical entity is created,
     * Emits event to set correct table view in parent component
     * @return {event}
     */
    physicalEntityCreated() {
      this.closeModal();
      this.$emit("setTableViewToPhysicalEntities");
    },
    /**
     * Show the modal
     * @return {void}
     */
    show() {
      this.$refs.bvModal.show();
    },
    /**
     * Close the modal
     * @return {void}
     */
    closeModal() {
      document.querySelector("#service_form_modal_close_btn").click();
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/bb-styles/modals/law-client-form-modal.scss";
</style>
